import React, { Fragment, useState, useCallback } from 'react';
import { Button, CssBaseline, TextField, Link, Grid, Typography } from '@material-ui/core';
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import ToastStr from '../../request/toastStr';

import axios from 'axios';

import { COLORS } from '../../shared/Theme';
import { SIcon } from '../../shared/Icon';

import { admin as v_admin, basic, Values, SNACKBAR_TIME } from '../../request/values';
import { useSnackbar } from 'notistack';

const SERVER = basic.server;

const useStyles = makeStyles((theme: any) => ({
	background: {
		position: 'absolute',
		top: 0,
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	container: {
		padding: 0,
		height: '100vh',
		paddingTop: '15vh',
	},
	paper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	title: {
		width: '30vw',
		alignItems: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '30vw', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	login: {
		height: '50px',
		width: '30vw',
		margin: theme.spacing(3, 0, 2),
		borderRadius: '15px',
		boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
		border: 'solid 0.5px #cfd4d9',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		marginBottom: 0,
		'&:hover': {
			backgroundColor: `${COLORS.WATER_BLUE}`,
		},
	},
	signin: {
		height: '50px',
		width: '30vw',
		margin: theme.spacing(3, 0, 2),
		borderRadius: '15px',
		boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
		border: 'solid 0.5px #cfd4d9',
		backgroundColor: `${COLORS.PUMPKIN}`,
		marginTop: '1vh',
		'&:hover': {
			backgroundColor: `${COLORS.PUMPKIN}`,
		},
	},
	submitButton: {
		'& :hover': {
			backgroundColor: `${COLORS.WATER_BLUE}`,
		},
	},
	logoSection: {
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',
		marginTop: '20vh',
		marginBottom: '10vh',
	},
	logobutton: {
		border: 'none',
		backgroundColor: 'transparent',
	},
	buttonFont: {
		color: `${COLORS.WHITE}`,
		fontSize: '2vw',
	},
	border: {
		borderWidth: 5,
		borderStyle: 'solid',
		borderColor: `#000000`,
		background: `${COLORS.WHITE}`,
		padding: '1vw',
		marginTop: '1vh',
	},
}));

const AdminLogin: React.FC<any> = (props) => {
	const classes = useStyles();

	const [member_email, setEmail] = useState<any | null>();
	const [member_password, setPassword] = useState<any | null>();
	const history = useHistory();
	const [cookies, setCookie, removeCookie] = useCookies();
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const { member, setMember, token } = props;

	const handleLogin = (member: any) => {
		history.push('/subAdminClassList');
		console.log('login success');
	};

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;

		if (id == 'member_email') setEmail(value);
		else setPassword(value);
	};

	const submitHandler = (event: any) => {
		axios({
			method: 'POST',
			data: {
				email: member_email,
				password: member_password,
				token: token,
			},
			withCredentials: true,
			url: SERVER + v_admin.admin + v_admin.login,
		})
			.then((res) => {
				console.log('res?', res);
				return res.data;
			})
			.then((data: any) => {
				if (data.code == Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.LOGIN_FAIL, {
						variant: 'error',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code == '1004') {
					enqueueSnackbar(ToastStr.LOGIN_NO_AUTHORITY, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else {
					setCookie('access', data.jwt);
					axios.defaults.headers.common['Authorization'] = `Bearer ${data.jwt}`;
					setMember(data.member);
					handleLogin(data.member);

					if (window.ReactNativeWebView) {
						console.log('to rn!!', data.member.id);
						window.ReactNativeWebView.postMessage(data.member.id);
					}
				}
			})
			.catch((error: any) => {
				if (error.response) {
					console.log('error?', error.response);
					if (error.response.status == 400) {
						enqueueSnackbar(ToastStr.LOGIN_FAIL, {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else if (error.response.status == 401) {
						enqueueSnackbar(ToastStr.PWD_CHECK_FALSE_STR, {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
					}
				}
			});
	};

	const moveSignin = () => {
		console.log('helllo');
		history.push('/signin');
	};

	return (
		<div className={classes.background}>
			<Container component="main" className={classes.container}>
				<CssBaseline />
				<div className={classes.paper}>
					<div className={classes.title}>
						<Typography
							variant="h2"
							style={{
								color: `${COLORS.WATER_BLUE}`,
								textAlign: 'center',
								fontWeight: 'bold',
							}}
						>
							플레이스타트업
						</Typography>
						<Typography
							variant="h2"
							style={{
								color: `${COLORS.WATER_BLUE}`,
								textAlign: 'center',
								fontWeight: 'bold',
							}}
						>
							운영자 페이지
						</Typography>
					</div>
					<div className={classes.border}>
						<Typography
							style={{
								color: `${COLORS.BLACK}`,
								textAlign: 'left',
								fontWeight: 'bold',
								fontSize: '1.5vw',
							}}
						>
							로그인
						</Typography>
						<div className={classes.form}>
							<TextField
								variant="standard"
								margin="normal"
								required
								fullWidth
								id="member_email"
								label="ID"
								name="email"
								autoComplete="email"
								autoFocus
								value={member_email}
								onChange={valueChangeHandler}
								style={{
									color: `${COLORS.charcoal_grey}`,
									marginTop: 0,
								}}
							/>
							<TextField
								variant="standard"
								margin="normal"
								required
								fullWidth
								name="password"
								label="PASSWORD"
								type="password"
								id="member_password"
								autoComplete="current-password"
								value={member_password}
								onChange={valueChangeHandler}
								style={{ color: `${COLORS.charcoal_grey}` }}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										submitHandler(e);
									}
								}}
							/>
							<Button
								// type="submit"
								fullWidth
								variant="contained"
								className={classes.login}
								onClick={(e) => submitHandler(e)}
							>
								<Typography className={classes.buttonFont}>로그인하기</Typography>
							</Button>

							<Button
								// type="submit"
								fullWidth
								variant="contained"
								className={classes.signin}
								onClick={(e) => moveSignin()}
							>
								<Typography className={classes.buttonFont}>회원가입하기</Typography>
							</Button>
						</div>
					</div>
					<div className={classes.logoSection}>
						<SIcon type="P" />
					</div>
				</div>
			</Container>
		</div>
	);
};

export default AdminLogin;
